import { FC } from 'react'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { FlexRow } from 'src/components/flex-containers'
import { MapSquareIcon } from 'src/components/map-square-icon'
import { Colors, Shapes } from 'src/components/theme'
import { MyLocation } from '@emotion-icons/material/MyLocation'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { SidebarCloseButton } from 'src/v2/views/owner-reveal/sidebar/siebar-result-return-header'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${Shapes.spacing[2]}px ${Shapes.spacing[4]}px;
  background-color: ${Colors.neutral50};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[1]}px;
  padding-block: ${Shapes.spacing[1]}px;
  button {
    border-radius: 999px;
  }
`

type ResultsToggleProps = {
  hasNearbyResults: boolean
  hasParcelResults: boolean
  activeResultsType: 'nearby' | 'parcels'
  setResultsType: (type: 'nearby' | 'parcels') => void
  nearbyCount: number
  parcelCount: number
  onClose?: () => void
}

export const SearchResultsToggle: FC<ResultsToggleProps> = ({
  hasNearbyResults,
  hasParcelResults,
  setResultsType,
  activeResultsType,
  nearbyCount,
  parcelCount,
  onClose,
}) => {
  const onClick = (type: 'nearby' | 'parcels') => {
    setResultsType(type)
  }

  return (
    <Container>
      <Content>
        <Typography variant="textmd" color={Colors.neutral700}>
          Search Results:
        </Typography>
        <FlexRow gap={Shapes.spacing[2]} align="center">
          <ButtonWithIcon
            id={COMMANDAI_IDS_MAP.mapExplorer['nearby-matches-button']}
            color={Colors.blueDark}
            disabled={!hasNearbyResults}
            active={activeResultsType === 'nearby'}
            onClick={() => onClick('nearby')}>
            <MyLocation size={14} />
            <Typography variant="text1">Nearby Matches ({nearbyCount})</Typography>
          </ButtonWithIcon>
          {parcelCount > 0 && (
            <ButtonWithIcon
              id={COMMANDAI_IDS_MAP.mapExplorer['within-parcels-button']}
              color={Colors.blueDark}
              disabled={!hasParcelResults}
              active={activeResultsType === 'parcels'}
              onClick={() => onClick('parcels')}>
              <MapSquareIcon />
              <Typography variant="text1">Within Parcel ({parcelCount})</Typography>
            </ButtonWithIcon>
          )}
        </FlexRow>
      </Content>
      {onClose && <SidebarCloseButton onClose={onClose} />}
    </Container>
  )
}
